<script lang="ts">
  /**
   * Interim whole-signal waveform (min/max per pixel from the peak pyramid).
   * Replaced by the full Overview/Zoom views in M3.
   */
  import { PeakPyramid } from '../../dsp/peaks';
  import { formatTime } from '../format';

  let { samples, sampleRate }: { samples: Float32Array; sampleRate: number } = $props();

  let canvas: HTMLCanvasElement;
  let width = $state(600);
  const height = 160;
  const pyramid = $derived(PeakPyramid.fromSamples(samples));

  $effect(() => {
    const dpr = Math.min(2, window.devicePixelRatio || 1);
    const w = Math.max(1, Math.floor(width));
    canvas.width = Math.round(w * dpr);
    canvas.height = Math.round(height * dpr);
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    const css = getComputedStyle(canvas);
    ctx.clearRect(0, 0, w, height);
    const plotH = height - 18;
    const mid = plotH / 2;
    ctx.strokeStyle = css.getPropertyValue('--border');
    ctx.beginPath();
    ctx.moveTo(0, mid + 0.5);
    ctx.lineTo(w, mid + 0.5);
    ctx.stroke();

    const mn = new Float32Array(w);
    const mx = new Float32Array(w);
    const spp = samples.length / w;
    pyramid.query(samples, 0, spp, w, mn, mx);
    ctx.fillStyle = css.getPropertyValue('--accent');
    for (let x = 0; x < w; x++) {
      if (Number.isNaN(mn[x]!)) continue;
      const y0 = mid - mx[x]! * mid;
      const y1 = mid - mn[x]! * mid;
      ctx.fillRect(x, y0, 1, Math.max(1, y1 - y0));
    }
    // time axis
    const dur = samples.length / sampleRate;
    ctx.fillStyle = css.getPropertyValue('--muted');
    ctx.font = '11px system-ui, sans-serif';
    ctx.textBaseline = 'bottom';
    const ticks = 5;
    for (let i = 0; i <= ticks; i++) {
      const t = (dur * i) / ticks;
      const x = (w * i) / ticks;
      ctx.textAlign = i === 0 ? 'left' : i === ticks ? 'right' : 'center';
      ctx.fillText(formatTime(t), x, height);
    }
  });
</script>

<div class="wrap" bind:clientWidth={width}>
  <canvas bind:this={canvas} style:height="{height}px" aria-label="Waveform of the whole signal"
  ></canvas>
</div>

<style>
  .wrap {
    width: 100%;
  }
  canvas {
    width: 100%;
    display: block;
    background: var(--bg);
    border: 1px solid var(--border);
    border-radius: var(--radius);
  }
</style>
